export enum ProjectPerformanceReviewStatuses {
  Completed = 'Completed',
  InProgress = 'In Progress',
  NotStarted = 'Not Started'
}
